import React, { useContext, useState } from 'react'
import { Box } from '../../../designSystem'
import { AccountContext } from '../../../providers/accountProvider'
import {
  BookAction,
  bookProgressBar,
  bottomCardSection,
  ProgressDivInner,
  progressDivOuter,
  wordsProgress,
} from '../style'

function ProgressBar({
  book,
  isNonIndianAndNonUSUser,
  toggleCountryPopup,
  toggleApplySnack,
  novelApply,
}) {
  const { user } = useContext(AccountContext)
  const isPublished =
    book?.status === 'published' || book?.status === 'approved'
  const isCreated = book?.application_status === 'created'
  const isEligible = book?.application_status === 'eligible'
  const isPending = book?.application_status === 'pending'
  const isApproved = book?.application_status === 'approved'
  const isLanguageNotAllowedForWBP = !['hindi', 'tamil', 'english'].includes(
    book.language
  )

  const handleApplyNow = () => {
    if (
      book.word_count >= 50000 &&
      !(book.status === 'approved' || book.status === 'published')
    ) {
      toggleApplySnack(true)
      return
    }
    if (book.is_eligible) {
      if (
        user?.location == null ||
        user?.location === '' ||
        user?.location?.length > 2
      ) {
        toggleCountryPopup(true)
      } else {
        novelApply(book.book_id)
      }
    }
  }

  if (!isPublished) return null
  if (isLanguageNotAllowedForWBP) return null
  if (isNonIndianAndNonUSUser) return null
  if (
    (isPending || isApproved) &&
    book.word_count > (book?.application_threshold || 30000)
  )
    return null
  return (
    <Box {...bottomCardSection}>
      <Box {...bookProgressBar}>
        <Box {...wordsProgress}>
          {book.word_count || 0} / {book.application_threshold}
        </Box>
        <Box {...progressDivOuter}>
          <ProgressDivInner
            width={
              (book.word_count / book.application_threshold) * 100 > 100
                ? 100
                : (book.word_count / book.application_threshold) * 100
            }
          />
        </Box>
      </Box>

      <BookAction
        onClick={handleApplyNow}
        enabled={book.is_eligible && !isCreated}
      >
        {isCreated || isEligible ? 'Submit Details' : 'Apply Now'}
      </BookAction>
    </Box>
  )
}

export default ProgressBar
